import * as React from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';

/**
 * The Workkard was created.
 *
 * The sponsor the Workkard was opened for is the "to" side of the creation
 * change, which is why it reads off the change rather than a dedicated field.
 */
export default function WorkkardTemplate({ data }) {
    const change = data.change || {};
    return (
        <div className="combinedListing detailListing">
            <span className="time_line_bar"></span>
            <div className="combinedCreatedDate detailCreatedDate">
                <ActorAvatar userId={data.actor_id} />
            </div>
            <div className="combinedRightBlock detailRightBlock resolutionChanged">
                <div className="combinedDescription detailDescription">
                    <div className="alignMiddle mb mb__8 flexWrap">
                        <ActorName userId={data.actor_id} inner="header" />
                        <span className="dateTime mr">
                            <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                        </span>
                        created this workkard
                        {change.to_value && <span className="ml mr">for {change.to_value}</span>}
                    </div>
                </div>
            </div>
        </div>
    )
}
